module.exports = __webpack_public_path__ + "img/whatsapp_1.20202cd2.png";